export class PatientSearchModel {
  ContactId: string;
  ContactMethod: string;
  FirstName: string;
  LastName: string;
  MidName: string;
  PatientId: string;
  PatientNO: string;
  PhoneAddress: string;
  addressContainsSearchTerm: boolean;
  BirthDate: string;
  Contact: string;
}
